import { render, staticRenderFns } from "./VerificationHistoryLayout.vue?vue&type=template&id=e059f776"
import script from "./VerificationHistoryLayout.vue?vue&type=script&lang=js"
export * from "./VerificationHistoryLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../Development/QC/qcheck-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports